import React from 'react';
import { Send, MapPin } from 'lucide-react';
import Logo from 'src/assets/images/nambi-logo.png'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'Overview', href: '#' },
    { label: 'Features', href: '#services' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Careers', href: '#' },
    { label: 'Help', href: '#' },
    { label: 'Privacy', href: '#' }
  ];

  return (
    <footer className="bg-gradient-to-b from-[#0f1420] to-[#0a0e1a] border-t border-white/10">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="lg:col-span-2 space-y-4">
            <img
              src={Logo}
              alt="NambiTech Logo"
              className="h-12 w-auto object-contain"
            />
            <p className="text-gray-400 max-w-md leading-relaxed">
              Building innovative blockchain and AI solutions for startups and enterprises since 2018. Empowering innovation through cutting-edge technology.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-gray-400">
                <Send size={18} className="text-[#ff6b35]" />
                <a href="https://t.me/darkerthandeath" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
                  Telegram: @darkerthandeath
                </a>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin size={18} className="text-[#ff6b35]" />
                <span>Singapore</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {footerLinks.slice(0, 3).map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-bold mb-4">Resources</h4>
            <ul className="space-y-2">
              {footerLinks.slice(3).map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Nambi Technologies PTE LTD. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;